import jsPDF from 'jspdf';

// Parámetros globales de la marca
export const BRAND_COLORS = {
  primary: [2, 21, 82],      // Azul Profundo
  secondary: [71, 85, 105],  // Slate 600 (Para textos secundarios)
  accent: [16, 185, 129],    // Emerald
  light: [241, 245, 249],    // Slate 100 (Para líneas)
  white: [255, 255, 255],
  black:[0,0,0],
};

/**
 * Configura la instancia inicial del PDF
 */
export const createBasePDF = (orientation = 'p', size = 'letter') => {
  return new jsPDF({
    orientation: orientation,
    unit: 'mm',
    format: size,
    putOnlyUsedFonts: true
  });
};